import { unsafeCSS, html } from "lit";
import { property, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { I18nController } from "../../utilities/i18n.js";
import { LeafElement } from "../leaf-element.js";
const styles = '@charset "UTF-8";\n/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n/* ------------------------------------*\\\n    #TYPOGRAPHY PLACEHOLDERS\n\\*------------------------------------ */\n.leaf-c-progress-bar ::slotted([slot=heading]) {\n  font-family: var(--leaf-typography-title-default-font-family);\n  font-size: var(--leaf-typography-title-default-font-size);\n  font-weight: var(--leaf-typography-title-default-font-weight);\n  line-height: var(--leaf-typography-title-default-line-height);\n  -webkit-text-decoration: var(--leaf-typography-title-default-text-decoration);\n          text-decoration: var(--leaf-typography-title-default-text-decoration);\n  text-transform: var(--leaf-typography-title-default-text-transform);\n}\n\n.leaf-c-progress-bar {\n  font-family: var(--leaf-typography-label-default-font-family);\n  font-size: var(--leaf-typography-label-default-font-size);\n  font-weight: var(--leaf-typography-label-default-font-weight);\n  line-height: var(--leaf-typography-label-default-line-height);\n  -webkit-text-decoration: var(--leaf-typography-label-default-text-decoration);\n          text-decoration: var(--leaf-typography-label-default-text-decoration);\n  text-transform: var(--leaf-typography-label-default-text-transform);\n}\n\n/*\n  Hiding class, making content visible only to screen readers but not visually ("sr" meaning "screen-reader")\n  Is the hidden content read by a screen reader?	- Yes\n  Will the hidden element affect the document layout? - No\n  Will the hidden element’s box model be rendered? - No\n  Does the element detect clicks or focus? - Yes\n  https://css-tricks.com/comparing-various-ways-to-hide-things-in-css/#method-5-the-visually-hidden-class\n*/\n:host leaf-icon[name=check-circle] {\n  --icon-height: var(--leaf-spacing-24);\n  color: var(--leaf-color-content-success);\n}\n\n:host([status=complete]) {\n  flex-direction: row;\n  gap: inherit;\n}\n\n.leaf-c-progress-bar {\n  --progress-bar-color: var(--leaf-color-content-brand);\n  --progress-bar-border-color: var(--leaf-color-border-strong);\n}\n.leaf-c-progress-bar .progress-status {\n  display: flex;\n  flex-direction: column;\n}\n.leaf-c-progress-bar .progress {\n  background: var(--leaf-color-bg-opacity-transparent);\n  border-color: var(--progress-bar-border-color);\n  border-radius: var(--leaf-border-radius-round);\n  border-style: solid;\n  border-width: var(--leaf-border-width-default);\n  display: inline-block;\n  height: var(--leaf-progress-meter-height);\n  overflow: hidden;\n  width: 100%;\n}\n.leaf-c-progress-bar .progress .progress-bar {\n  background: var(--progress-bar-color);\n  height: 100%;\n  width: calc(var(--progress-bar-value) * 1%);\n}\n.leaf-c-progress-bar ::slotted([slot=heading]) {\n  color: var(--leaf-color-content-brand-strong);\n}\n@media (min-width: 35rem) {\n  .leaf-c-progress-bar {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: var(--leaf-spacing-32);\n    justify-content: space-between;\n  }\n  .leaf-c-progress-bar .progress-status {\n    align-items: center;\n    flex: 50%;\n    flex-direction: row !important;\n    gap: var(--leaf-spacing-8);\n    max-width: -moz-fit-content;\n    max-width: fit-content;\n  }\n  .leaf-c-progress-bar .progress-status .prefix {\n    display: block;\n  }\n  .leaf-c-progress-bar .progress-status .suffix span {\n    display: none;\n  }\n  .leaf-c-progress-bar .progress {\n    width: 15rem;\n  }\n}\n\n.leaf-c-progress-bar--inverted {\n  --progress-bar-color: var(--leaf-color-content-brand-knockout);\n  --progress-bar-border-color: var(--leaf-color-border-default);\n}\n.leaf-c-progress-bar--inverted ::slotted([slot=heading]) {\n  color: var(--leaf-color-content-knockout);\n}\n\n.leaf-c-progress-bar--percentage .progress-status {\n  flex-direction: column-reverse;\n}\n.leaf-c-progress-bar--percentage .progress-status .prefix {\n  display: none;\n}\n@media (min-width: 35rem) {\n  .leaf-c-progress-bar--percentage .progress-status .prefix {\n    display: block;\n  }\n}\n\n.leaf-c-progress-bar--plain ::slotted([slot=heading]) {\n  display: none !important;\n}\n.leaf-c-progress-bar--plain .progress-status {\n  justify-content: unset;\n  max-width: unset;\n}\n.leaf-c-progress-bar--plain .progress-status .prefix,\n.leaf-c-progress-bar--plain .progress-status .suffix {\n  display: none;\n}\n@media (min-width: 35rem) {\n  .leaf-c-progress-bar--plain .progress-status .prefix,\n  .leaf-c-progress-bar--plain .progress-status .suffix {\n    display: none;\n  }\n}\n.leaf-c-progress-bar--plain .progress-status .progress {\n  width: 100%;\n}\n\n.leaf-c-progress-bar--complete {\n  justify-content: unset;\n  gap: unset;\n}';
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafProgressBar = class _LeafProgressBar extends LeafElement {
  constructor() {
    super(...arguments);
    this.i18nController = new I18nController(this);
    this.internals = this.attachInternals();
    this.inverted = false;
    this.showEmptyBar = true;
    this.showFullBar = true;
    this.precision = 0;
    this.value = 0;
    this.variant = "percentage";
  }
  get clampedValue() {
    return Math.min(Math.max(this.value, 0), this.max);
  }
  get numberFormatAPI() {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: this.precision,
      maximumFractionDigits: this.precision
    });
  }
  get state() {
    if (this.clampedValue === 0 && !this.showEmptyBar) {
      return "initial";
    }
    if (this.clampedValue === this.max && !this.showFullBar) {
      return "complete";
    }
    return "in-progress";
  }
  get percentage() {
    if (!this.max) {
      return 0;
    }
    const getPercentageValue = this.clampedValue / this.max * 100;
    return getPercentageValue % 1 === 0 ? Math.round(getPercentageValue) : this.numberFormatAPI.format(getPercentageValue);
  }
  renderPrefix() {
    if (this.variant === "percentage") {
      return html`<p class="prefix">${this.i18nController.term("your_progress")}</p>`;
    }
    return html`
      <p class="prefix">
        ${this.i18nController.term("step")} ${this.clampedValue} ${this.i18nController.term("of")} ${this.max}
      </p>
    `;
  }
  renderSuffix() {
    if (this.variant === "percentage") {
      return html`<p class="suffix">${this.percentage}%<span> ${this.i18nController.term("complete")}</span></p>`;
    }
    return html``;
  }
  render() {
    const componentClassName = {
      "leaf-c-progress-bar": true,
      "leaf-c-progress-bar--inverted": this.inverted,
      "leaf-c-progress-bar--percentage": this.variant === "percentage",
      "leaf-c-progress-bar--step": this.variant === "step",
      "leaf-c-progress-bar--plain": this.variant === "plain",
      "leaf-c-progress-bar--complete": this.state === "complete"
    };
    const showStatus = this.state === "initial" || this.state === "in-progress";
    let statusHtml;
    if (showStatus) {
      if (this.state === "initial") {
        statusHtml = html`<slot name="label"></slot>`;
      } else {
        statusHtml = html`
          ${this.renderPrefix()}
          <div class="progress">
            <div class="progress-bar" style="--progress-bar-value: ${this.percentage};"></div>
          </div>
          ${this.renderSuffix()}
        `;
      }
    }
    return html`<div class=${classMap(componentClassName)}>
      ${this.state === "complete" ? "" : html`<slot name="heading"></slot>`}
      ${showStatus ? html`<div class="progress-status">${statusHtml}</div>` : ""}
      ${this.state === "complete" ? html`
            <leaf-icon set="system" name="check-circle"></leaf-icon>
            <slot name="success"></slot>
          ` : ""}
    </div>`;
  }
};
_LeafProgressBar.styles = unsafeCSS(styles);
_LeafProgressBar.formAssociated = true;
let LeafProgressBar = _LeafProgressBar;
__decorateClass([
  property({ attribute: "status" })
], LeafProgressBar.prototype, "status", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafProgressBar.prototype, "inverted", 2);
__decorateClass([
  property({ reflect: true, type: Number })
], LeafProgressBar.prototype, "max", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafProgressBar.prototype, "showEmptyBar", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], LeafProgressBar.prototype, "showFullBar", 2);
__decorateClass([
  property({ type: Number, reflect: true })
], LeafProgressBar.prototype, "precision", 2);
__decorateClass([
  property({ reflect: true, type: Number })
], LeafProgressBar.prototype, "value", 2);
__decorateClass([
  property({ type: String, reflect: true })
], LeafProgressBar.prototype, "variant", 2);
__decorateClass([
  state()
], LeafProgressBar.prototype, "clampedValue", 1);
__decorateClass([
  state()
], LeafProgressBar.prototype, "numberFormatAPI", 1);
export {
  LeafProgressBar
};
//# sourceMappingURL=progress-bar.component.js.map
